import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { HelpItem, HelpItemService } from 'huddyapi';
import { Select } from '@ngxs/store';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'helpTooltip',
  templateUrl: 'helpTooltip.component.html',
  styleUrls: ['./helpTooltip.component.scss'],
  providers: []
})
export class HelpTooltip {
  @Input() context: string;
  @Input() backgroundColor: string;

  @ViewChild('infoButton') infoButton: MatButton;
  @ViewChild('popover') popover: ElementRef;

  //@Select(state => state.helpItemState.helpItems) helpItem$: Observable<HelpItem[]>;
  helpItems: HelpItem[];
  contextItems: HelpItem[];
  header: string;
  infoPopoverShowing: boolean;
  infoPopoverShown: boolean;
  infoPopoverPosition: string;

  constructor(private helpItemService: HelpItemService){
    //this.helpItem$.subscribe(helpItems => {
    this.infoPopoverShowing = false;
    this.infoPopoverShown = false;
    this.infoPopoverPosition = '';
    helpItemService.getForProduct('desktop').subscribe((helpItems: HelpItem[]) => {
      this.helpItems = helpItems;
      this.syncContextItems();
    });
  }

  syncContextItems(){
    if(this.helpItems && this.helpItems.length > 0 && this.context){
      this.contextItems = this.helpItems.filter(i => i.context === this.context);
      this.header = this.context.substr(0, 1).toUpperCase() + this.context.substr(1);
    }
  }

  getInfoPopoverPosition() {
    let top: number = 0, left: number = 0;
    if(this.infoPopoverShown && this.popover && this.popover.nativeElement) {
      const bodyPosition = this.popover.nativeElement.parentElement.getBoundingClientRect();
      top = bodyPosition.y + 38;
      left = bodyPosition.x - 10;
    }
    return 'top:' + top + 'px;left:' + left + 'px;';
  }

  showInfoPopover() {
    if(!this.infoPopoverShown)
      this.infoPopoverShown = true;
    this.infoPopoverShowing = true;
  }

  hideInfoPopover() {
    this.infoPopoverShowing = false;
  }

  getBackgroundColor() {
    return 'background-color:' + this.backgroundColor;
  }
}
